
import http from "../services/http-common";
import RsaEncriptar from "../services/RsaEncriptar";
import Crypto from "../services/Crypto";
import { getServidorPorAmbiente } from "../utils/Utils";

const VERSION = process.env.VUE_APP_VERSION_SISTEMA;

const puerto = process.env.VUE_APP_PUERTO;

export default {
    login(datos, publicKey, infoDevice) {

        const payload = {
            data: RsaEncriptar.encriptar(datos, publicKey),
            infoDevice: encodeURIComponent(infoDevice)
        };

        return http.post(`${getServidorPorAmbiente()}/api/auth/login`, payload);
    },

    /**
     * Verifica si un nombre de usuario existe en el sistema. Se usa en el
     * primer paso del login para decidir si se solicita la contraseña.
     * @param {string} username nombre de usuario a verificar
     */
    existeUsuario(username) {
        return http.post(`${getServidorPorAmbiente()}/api/auth/existe-usuario`, { username });
    },

    /**
     * Elimina el registro de sesión activa en el servidor (allowlist), para
     * que la cuenta quede libre para volver a iniciar sesión.
     * @param {string} token token de la sesión a cerrar
     * @param {string} tokenPush token de notificaciones push asociado
     */
    eliminarToken(token, tokenPush) {
        return http.post(`${getServidorPorAmbiente()}/api/auth/eliminar-token`, {
            token,
            tokenPush: tokenPush || "",
        });
    },

    async verificaAcceso(data, key, config = {}) {
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.post(`${getServidorPorAmbiente()}/api/auth/validar`, datosEncriptados, { ...config, customTag: "verificaAcceso" });
    },

    // getPublicKey(){
    //     return http.get(`https://localhost:49171/asincrona/api/auth/getKey/`)
    // },

    version() {
        return VERSION;
    },
    navegador() {
        let ua = navigator.userAgent;
        let nombreNav = '';
        try {
            const expresion = /Chrome/;
            let indice = ua.search(expresion);
            if (indice > -1) {
                nombreNav = ua.substring(indice, indice + 11);
            } else {
                nombreNav = 'No recomendado';
            }
        } catch (error) {
            console.error(error);
            nombreNav = 'No se pudo determinar';
        }
        return nombreNav;
    },

};
